import { useEffect } from 'react';
import { App } from 'antd';
import { registerNotify } from './notify';

/**
 * Kök antd <App> içinde çalışır; context-aware notification örneğini global
 * holder'a (notify.js) kaydeder. Böylece class bileşenleri statik notification
 * yerine `notify`yi kullanıp tema uyarısını almadan bildirim gösterebilir.
 */
const AntdAppBridge = ({ children }) => {
    const { notification } = App.useApp();

    useEffect(() => {
        registerNotify(notification);
    }, [notification]);

    return children;
};

export default AntdAppBridge;
